import useAsyncData from '../../hooks/useAsyncData/useAsyncData';
import { offers } from '../../api/client/adobe';
import { parseCookie } from '../../utilities/utils';

const initialiser = parseCookie('mbox') ? undefined : window?.onLoadTarget;
const useHtmlOfferData = () => useAsyncData(offers, initialiser);

export default useHtmlOfferData;
